import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

export type PillProps = {
  backgroundColor: string;
  onClick: () => void;
  children: ReactNode;
};

const Pill: FC<PillProps> = ({ backgroundColor, onClick, children }) => {
  return (
    <Container backgroundColor={backgroundColor} onClick={onClick}>
      {children}
    </Container>
  );
};

export default Pill;

const Container = styled.div<PillProps>`
  min-width: 84px;
  height: 36px;
  display: flex;
  justify-content: center;
  padding: 0 12px;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${(p) => p.backgroundColor};
`;
